// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const CustomSearchField = (
   // @ts-expect-error TS(7006) FIXME: Parameter 'advSearchService' implicitly has an 'an... Remove this comment to see the full error message
   advSearchService,
   // @ts-expect-error TS(7006) FIXME: Parameter '$booleanValues' implicitly has an 'any'... Remove this comment to see the full error message
   $booleanValues,
   // @ts-expect-error TS(7006) FIXME: Parameter '$queryModifiers' implicitly has an 'any... Remove this comment to see the full error message
   $queryModifiers,
   // @ts-expect-error TS(7006) FIXME: Parameter '$identifierQueryModifiers' implicitly h... Remove this comment to see the full error message
   $identifierQueryModifiers,
   // @ts-expect-error TS(7006) FIXME: Parameter '$identifierFields' implicitly has an 'a... Remove this comment to see the full error message
   $identifierFields,
   // @ts-expect-error TS(7006) FIXME: Parameter '$minLengthForBeginsWithQueries' implici... Remove this comment to see the full error message
   $minLengthForBeginsWithQueries
) => ({
   templateUrl: '/assets/advancedSearch/customSearchField.html',
   controller: 'AdvancedSearchCtrl',

   scope: {
      model: '=',
      fields: '=',
      index: '@',
      addField: '&',
      removeField: '&',
      parentForm: '<?',
      scopeBuilderMode: '<?'
   },

   link(scope: any) {
      scope.fieldNumber = parseInt(scope.index) + 1
      scope.booleanValues = $booleanValues
      scope.selectedField = (_.find(scope.fields, (field: any) => field.key === scope.model.key))
      // this is for accessibility, when removing an item this can be used to focus on the next
      scope.focusNext = (e: any) => $(e.target).parents('.customField').next().find(':focusable:eq(0)').focus()
      if (!scope.model.queryModifier && !scope.scopeBuilderMode) { // set the default value for this field when there is no queryModifier selected
         scope.model.queryModifier = $identifierFields.includes(scope.model.key) ? 'ExactMatch' : 'AllWords'
      } else if (scope.scopeBuilderMode) {
         scope.model.queryModifier = 'ExactMatch'
      }
      scope.getApplicableModifiers = function () {
         if ($identifierFields.includes(scope.model.key)) { return $identifierQueryModifiers }
         if (['TitleCombined', 'PublicationTitle'].includes(scope.model.key)) { return $queryModifiers }
         if (scope.model.key == 'Notes') { return ['AllWords', 'ExactMatch'] }
         return []
      }
      scope.displayModifiers = () => (['TitleCombined', 'PublicationTitle', 'Notes'].includes(scope.model.key) || $identifierFields.includes(scope.model.key)) && !scope.scopeBuilderMode
      scope.setModifier = function () {
         scope.selectedField = (_.find(scope.fields, (field: any) => field.key === scope.model.key))
         // Set default query modifier for key when key is selected
         return scope.model.queryModifier = $identifierFields.includes(scope.model.key) ? 'ExactMatch' : 'AllWords'
      }
      scope.updateValidators = () => // Set min length for term if query modifier is 'BeginsWith'
         scope.model.minLength = scope.model.queryModifier === 'BeginsWith' ? $minLengthForBeginsWithQueries : -1
      return scope.getFieldError = (field: any, errorName: any) => scope.parentForm[field].$error[errorName]
   }
})

const AdvSearchEnterSubmit = () => ({
   link(scope: any, el: any) {
      el.on("keypress", function (event: any) {
         if (event.keyCode === 13) {
            return angular.element("#advSearchSubmit").trigger("click")
         }
      })
      return el.on("destroy", () => el.off("keypress"))
   }
})

angular.module('summonApp.directives')
   .directive('customSearchField', ['advancedSearchService', '$booleanValues', '$queryModifiers', '$identifierQueryModifiers', '$identifierFields', '$minLengthForBeginsWithQueries', CustomSearchField])
   .directive('advSearchEnterSubmit', AdvSearchEnterSubmit)
